module.exports = __webpack_public_path__ + "static/media/UrlLink.d1b73344.svg";